import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { useOffersUK } from '../../../../hooks/useOffers/useOffersUK';
import { getAmplitudeDefaultEventProperties } from '../../../../utils/amplitudeEvents';
import { Button } from '../../../Button/Button';
import styles from '../SubmitDocuments.module.css';

type TProps = {
  isSubmitted: boolean;
  setIsSubmitted: (isSubmitted: boolean) => void;
  vatUploadRequired: boolean;
};
const SubmitDocumentsButtonUK = ({
  isSubmitted,
  setIsSubmitted,
  vatUploadRequired,
}: TProps) => {
  const {
    documentRequirements,
    handleDecision,
    isDeciding,
    isRefetchingOffers,
  } = useOffersUK({ enabled: false });

  useEffect(() => {
    if (!documentRequirements || !isSubmitted) {
      return;
    }

    const requiredDocumentType = documentRequirements.find(
      (requirement) =>
        requirement.is_optional === false &&
        (requirement.status === 'error' || requirement.status === 'required'),
    );

    const elementToScrollTo = document.getElementById(
      `document-requirement-${getDocumentRequirementId(
        requiredDocumentType?.type,
      )}`,
    );

    if (elementToScrollTo) {
      elementToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [documentRequirements, isSubmitted]);

  const handleClick = async () => {
    if (vatUploadRequired) {
      return setIsSubmitted(true);
    }

    tracking.ampli.tradingHistorySubmitted({
      'Page version': 'v2',
      ...getAmplitudeDefaultEventProperties(),
    });

    await handleDecision();
    setIsSubmitted(true);
  };

  const getDocumentRequirementId = (requirement?: string) => {
    if (!requirement) {
      return null;
    }

    if (requirement === 'company_accounts') {
      // This is because product_offers asks for "company_accounts"
      // But POST documents accepts it under "business accounts"
      return 'business accounts';
    }

    return requirement.split('_').join(' ');
  };

  return (
    <Button
      className={styles.button}
      loading={isDeciding || isRefetchingOffers}
      onClick={handleClick}
    >
      Send your application
    </Button>
  );
};

export default SubmitDocumentsButtonUK;
